import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { I1091Form } from 'legacy/lut/features/partner360/basicInfo/models/i1091Form'
import { TPartnerBasicInfo } from 'legacy/lut/features/partner360/basicInfo/models/partnerBasicInfo'

export const map1091ToBasicInfo = (data: I1091Form): TPartnerBasicInfo => {
  return {
    entryId: data.EntryId,
    partnerId: data.PartnerId,
    programType: data.ProgramType ? (data.ProgramType as ProgramTypes) : null,
    fYear: data.FYear,

    branchesIsApplicable:
      typeof data.BranchesNotApplicable === 'number' ? data.BranchesNotApplicable === 0 : true,
    branchesCount: data.BranchesCount,
    branchesLocations: data.BranchesLocations ?? '',

    turnover: data.Turnover,
    ppsShare: data.PPSShare,
    isMPSAuditRequirements:
      typeof data.MPSAuditRequirements === 'number' ? data.MPSAuditRequirements === 1 : false,
    summary: data.Summary ?? '',
    achievement: data.Achievement ?? '',

    operationProfit: data.OperationProfit,
    operationProfitYoY: data.OperationProfitYoY,
    ticker: data.Ticker ?? '',
    growthStrategy: data.GrowthStrategy ?? '',
    gtmOnlinePercentage: data.GTMOnlinePercentage,
    storesTotal: data.StoresTotal,
    storesPSHW: data.StoresPSHW,
    storesPRHW: data.StoresPRHW,

    showroomsIsApplicable:
      typeof data.ShowroomNotApplicable === 'number' ? data.ShowroomNotApplicable === 0 : true,
    showroomsCount: data.ShowroomsCount,
    showroomsLocations: data.ShowroomsLocations ?? '',
    salesCount: data.SalesCount,
    serviceCount: data.ServiceCount,
    demoUnits: data.DemoUnits,

    warehouseIsApplicable:
      typeof data.WarehouseNotApplicable === 'number' ? data.WarehouseNotApplicable === 0 : true,
    warehouseCount: data.WarehouseCount,
    warehouseLocations: data.WarehouseLocations ?? '',
    totalSales: data.TotalSales,
    hpDedicatedSales: data.HPDedicatedSales,
    employersCount: data.EmployersCount,
    exhibits: data.Exhibits ?? '',
    bridgeBaseline: data.BridgeBaseline,
  }
}
